import appSettings from 'wanderu-config';

function isLocalStorageAvailable() {
    if (!appSettings.env.isClient) {
        return false;
    }

    try {
        return _isStorageAvailable(window.localStorage);
    } catch {
        return false;
    }
}

function isSessionStorageAvailable() {
    if (!appSettings.env.isClient) {
        return false;
    }

    try {
        return _isStorageAvailable(window.sessionStorage);
    } catch {
        return false;
    }
}

function _isStorageAvailable(storage) {
    if (typeof storage === 'undefined') {
        return false;
    }

    const test = 'aKeyYouShouldNeverUse';
    try {
        storage.setItem(test, test);
        storage.removeItem(test);
        return true;
    } catch {
        return false;
    }
}

function areCookiesAvailable() {
    // NB: On the server, we can always attempt to read/set cookies via the headers
    if (!appSettings.env.isClient) {
        return true;
    }

    return navigator.cookieEnabled;
}

export {
    areCookiesAvailable,
    isLocalStorageAvailable,
    isSessionStorageAvailable,
};
export default {
    isLocalStorageAvailable,
    isSessionStorageAvailable,
    areCookiesAvailable,
};
